import { FC, useState } from "react";
import ControlledAccord from "./Controlled";
import { UncontrolledAccordProps } from "DataTypes/Common";

const UncontrolledAccord: FC<UncontrolledAccordProps> = (props) => {
  const { head, body } = props;
  const [open, setOpen] = useState(false);
  return (
    <ControlledAccord
      head={head}
      body={body}
      open={open}
      handleClick={() => setOpen(open ? false : true)}
    />
  );
};
export default UncontrolledAccord;
